import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import formatTimeLeft from '../../common/helpers/formatTimeLeft';
import parsePostContent from '../../common/helpers/parsePostContent';
export default class ArenaBattleNextTurnPost extends Component {
  timerId = null;

  /** Battle event posts that can only appear AFTER this turn prompt. */
  static LATER_BATTLE_POST_TYPES = ['arenaBattleTurn', 'arenaBattleWait', 'arenaBattleNext', 'arenaBattleSurrender', 'arenaBattleExpired', 'arenaBattleDraw'];

  /**
   * Whether the battle has visibly moved past this prompt: any later
   * battle post means this post's expiresAt snapshot is stale (a wait
   * post resets the timer server-side; a resolved turn or a final post
   * supersedes it entirely), so its countdown must not keep ticking —
   * old turns looked like several timers running in parallel. Checks
   * only posts already loaded into the store, i.e. exactly what the
   * viewer sees in the stream; regular user comments don't count.
   */
  isSuperseded() {
    const post = this.attrs.post;
    const discussion = post.discussion?.();
    if (!discussion) return false;
    const myNumber = post.number() ?? 0;
    return (discussion.posts?.() ?? []).some(p => p && p.id() !== post.id() && (p.number?.() ?? 0) > myNumber && ArenaBattleNextTurnPost.LATER_BATTLE_POST_TYPES.includes(p.contentType?.() ?? ''));
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.timerId = setInterval(() => m.redraw(), 60_000);
  }
  onremove(vnode) {
    if (this.timerId) clearInterval(this.timerId);
    super.onremove(vnode);
  }
  view() {
    const data = parsePostContent(this.attrs.post.content());
    if (!data) return null;

    // Once a later battle post exists, this prompt is stale — the player it
    // named has already moved (that's what produced the later post), so the
    // whole "whose turn"/timer line is now wrong, not just its countdown.
    // Drop it instead of leaving a dead announcement sitting in the stream.
    if (this.isSuperseded()) return null;
    const {
      nextPlayerId,
      nextPlayerName,
      challengerId,
      expiresAt
    } = data;
    const isNextChallenger = nextPlayerId === challengerId;
    const timeLeft = formatTimeLeft(expiresAt ?? null);
    return (
      // No "Ход N" heading here — ArenaBattleWaitPost right above already
      // shows one for the same turn number; this post only adds the
      // whose-turn/timer line.
      m("div", {
        className: "ArenaBattleNextPost EventPost"
      }, m("div", {
        className: "ArenaBattleNextPost-whosTurn"
      }, m("i", {
        className: `fas fa-${isNextChallenger ? 'caret-right' : 'caret-left'}`
      }), app.translator.trans('forumaker-arena.forum.battle_next.whos_turn', {
        name: m("strong", null, nextPlayerName)
      }), timeLeft && m("span", {
        className: "ArenaBattleNextPost-timer",
        title: app.translator.trans('forumaker-arena.forum.card_slider.timer_title')
      }, m("i", {
        className: "fas fa-clock"
      }), " ", timeLeft)))
    );
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/ArenaBattleNextTurnPost', ArenaBattleNextTurnPost);